import React, { Component } from 'react';
import { Row, Col, Button, Alert } from 'reactstrap';
import '../css/styleHome.css';
import HeaderComp from "../components/HeaderAgenteLogin"
import fondo from "../imgs/KLBackground.png"
import { Redirect } from 'react-router-dom';

class NoEncontrado extends Component {

    constructor(props) {
        super(props);
        this.state = {
            validacion: false,
            modulo: false,
        };
        this.irAHome = this.irAHome.bind(this);
        this.irAModulo = this.irAModulo.bind(this);
    }

    irAHome() {
        this.setState({ validacion: true })
    }

    irAModulo() {
        this.setState({ modulo: true })
    }

    componentDidMount() {
        document.title = "DigiturnoKL - ¡404!";
    }

    render() {
        if (this.state.modulo === false && this.state.validacion === false) {
            return (
                <div>
                    <div id="home">
                        <div className="bg-img" style={{ backgroundImage: "url(" + fondo + ")" }}>
                            <div className="overlay"></div>
                        </div>
                        <div className="home-wrapper">
                            <div className="container">
                                <Row>
                                    <Col xs="12">
                                        <div className="home-content">
                                            <HeaderComp></HeaderComp>
                                            <Col xs="12">
                                                <Alert color="light">
                                                    <p>¡404! Página no encontrada.</p>
                                                    <Button onClick={this.irAHome} color="info">Login Modulo</Button>{' '}
                                                    <Button onClick={this.irAModulo} color="success">Login Agentes</Button>
                                                </Alert>
                                            </Col>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            if (this.state.modulo === true) {
                return <Redirect to={{ pathname: '/Cliente' }} />
            }
            else {
                if (this.state.validacion === true) {
                    return <Redirect to={{ pathname: '/' }} />
                }
            }
        }


    }
}

export default NoEncontrado;
